import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/tm-check-car-icon.png'
import _imports_1 from '../../../assets/icons/tm-uncheck-car-icon.png'
import _imports_2 from '../../../assets/icons/check-icon1.png'
import _imports_3 from '../../../assets/icons/uncheck-icon1.png'
import _imports_4 from '../../../assets/images/enroll-popup-close-btn.png'


const _withScopeId = n => (_pushScopeId("data-v-7bd39f1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tm-receive-success-popup" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_3 = { class: "popup-box" }
const _hoisted_4 = { class: "money" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "¥ ", -1))
const _hoisted_6 = { class: "amount" }
const _hoisted_7 = { class: "select-other-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt1" }, "选择心仪车系即可领取", -1))
const _hoisted_9 = { class: "select-cars-box" }
const _hoisted_10 = {
  key: 0,
  class: "list"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_13 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_14 = { class: "serial-pic" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "serial-name" }
const _hoisted_17 = {
  key: 1,
  class: "no-data-list"
}
const _hoisted_18 = { class: "checkbox-wrap" }
const _hoisted_19 = { class: "checkbox" }
const _hoisted_20 = {
  key: 0,
  class: "hook-icon",
  src: _imports_2
}
const _hoisted_21 = {
  key: 1,
  class: "hook-icon",
  src: _imports_3
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击提交即视为同意", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip2" }, "勾选意向车系后，将会有购车顾问联系您", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_choose_car = _resolveComponent("choose-car")!
  const _component_pc_Popup = _resolveComponent("pc-Popup")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.lotteryResultBO.amount || 0.0), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", {
          class: "select-other-btn",
          id: "cxOhter",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectOther && _ctx.selectOther(...args)))
        }, "选择其他")
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.seriesBOList.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seriesBOList, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(['item', { 'check-item': item.isCheck }]),
                  key: index,
                  onClick: ($event: any) => (_ctx.handleSerailSelect(item, index))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['check-icon', { 'uncheck-icon': item.isCheck }])
                  }, [
                    (item.isCheck)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                      : (_openBlock(), _createElementBlock("img", _hoisted_13))
                  ], 2),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("img", {
                      src: item.serialGroupPic,
                      alt: ""
                    }, null, 8, _hoisted_15)
                  ]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(item.serialGroupName), 1)
                ], 10, _hoisted_11))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, "暂无相关推荐车系"))
      ]),
      _createElementVNode("div", {
        class: "receive-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleReceive && _ctx.handleReceive(...args)))
      }, "立即领取"),
      _createElementVNode("div", {
        class: "statement-tip1",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleStatement && _ctx.handleStatement(...args)))
      }, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            (_ctx.checkBoxNeedVerify)
              ? (_openBlock(), _createElementBlock("img", _hoisted_20))
              : (_openBlock(), _createElementBlock("img", _hoisted_21))
          ]),
          _hoisted_22,
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toLinkStatement && _ctx.toLinkStatement(...args))),
            href: "javascript:;"
          }, "《个人信息披露及保护声明》")
        ])
      ]),
      _hoisted_23,
      _createElementVNode("div", {
        class: "close-btn",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (
          _ctx.toggleTmReceiveRedPacketPopup({ isShowReceiveRedPacketPopup: false })
        ))
      }, _hoisted_25)
    ]),
    _createVNode(_component_pc_Popup, {
      show: _ctx.carSelectVisible,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.carSelectVisible) = $event)),
      popupType: 'carSidBar',
      onTogglePCPopupVisible: _ctx.toHideSelectCar
    }, {
      default: _withCtx(() => [
        _createVNode(_component_choose_car, {
          visible: _ctx.carSelectVisible,
          needModel: false,
          onToChooseCar: _ctx.toChooseCar
        }, null, 8, ["visible", "onToChooseCar"])
      ]),
      _: 1
    }, 8, ["show", "onTogglePCPopupVisible"])
  ], 512)), [
    [_vShow, _ctx.isShowReceiveRedPacketPopup]
  ])
}